import { Button, Modal } from 'rsuite';
import styles from './ModalConfirmarRemoverParaMim.module.scss';

type ModalConfirmarRemoverParaMimProps = {
  show: boolean;
  nomeMonitoramento?: string;
  onClose: () => void;
  onConfirm: () => void;
};

export const ModalConfirmarRemoverParaMim = ({ show, nomeMonitoramento, onClose, onConfirm }: ModalConfirmarRemoverParaMimProps) => (
  <Modal className={styles.modal} size="xs" show={show} onHide={onClose}>
    <Modal.Header closeButton>
      <Modal.Title className={styles.title}>Remover monitoramento da sua Central</Modal.Title>
    </Modal.Header>
    <Modal.Body className={styles.body}>
      <p>
        Tem certeza que deseja remover <strong>{nomeMonitoramento}</strong> da sua Central? Você deixará de receber os alertas desse
        monitoramento e <strong>não poderá ser compartilhado novamente</strong>. Essa ação não pode ser desfeita.
      </p>
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={onClose} appearance="ghost">
        Cancelar
      </Button>
      <Button onClick={onConfirm} appearance="primary" color="red">
        Remover
      </Button>
    </Modal.Footer>
  </Modal>
);
